import "./aboutUs.scss";
import instaIcon from "../../assets/images/icons/insta.svg";
import telIcon from "../../assets/images/icons/telegram.svg";

const AboutUs = ({ configs }) => {
  return (
    <div className="about-us-container">
      <div className="description">
        <h2>درباره ما</h2>
        <p>{configs.aboutUs}</p>
      </div>
      <div className="contact-container">
        <h2>تماس با ما</h2>
        <div className="contact">
          <div className="info">
            <div className="info-item">آدرس: {configs.address}</div>
            <div className="info-item">
              تلفن: <span className="ltr">&#x200E;{configs.phone}</span>
            </div>
            <div className="info-item">ایمیل: {configs.email}</div>
          </div>
          <iframe
            title="myframe"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d286.0954731629624!2d51.45189441029975!3d35.780269600428355!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e04362c9127cd%3A0xf78f4c224f49535f!2sChahrrah%20Qanat%20Petrol%20Station!5e0!3m2!1sen!2sde!4v1708258319288!5m2!1sen!2sde"
          ></iframe>
        </div>
      </div>
      <div className="socials">
        <h3>ما را در شبکه های اجتماعی دنبال کنید</h3>
        <div className="social-icons">
          <a href={`https://instagram.com/${configs?.instagram}`}>
            <img alt="social" src={instaIcon} />
          </a>
          <a href={`https://t.me/${configs?.telegram}`}>
            <img alt="social" src={telIcon} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
